// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j6-0";
export var fileCarousel = "_j6-2";
export var removeFileButton = "_j6-1";